import { Chuckle, Drip, Shiver, Bob, OnInk } from "./Characters";
import { Reveal } from "./Reveal";

export const WhoFor = () => (
  <section data-testid="who-for-section" className="relative overflow-hidden bg-pop py-20 text-ink sm:py-28">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-6 lg:grid-cols-[1.5fr_1fr] lg:px-10">
      <div>
        <Reveal><p className="font-body text-base font-semibold">Who it's for</p></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-3 font-head text-4xl leading-[1.02] tracking-tight sm:text-6xl lg:text-7xl">
            Independent filmmakers, animators, AI creators and first-timers.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p data-testid="who-for-blurb" className="mt-8 max-w-2xl font-body text-lg leading-relaxed sm:text-xl">
            AI or not, we hide how a film was made until results day. Judges and voters react to the feeling. Then we find out together.
          </p>
        </Reveal>
      </div>
      <div className="flex justify-start gap-3 lg:justify-end">
        <OnInk className="h-24 w-24 sm:h-32 sm:w-32"><Bob className="w-[64%]"><Chuckle className="h-auto w-full" /></Bob></OnInk>
        <OnInk className="mt-10 h-24 w-24 sm:h-32 sm:w-32"><Bob delay={0.6} className="w-[64%]"><Drip className="h-auto w-full" /></Bob></OnInk>
        <OnInk className="h-24 w-24 sm:h-32 sm:w-32"><Bob delay={1.2} className="w-[64%]"><Shiver className="h-auto w-full" /></Bob></OnInk>
      </div>
    </div>
  </section>
);
